import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Input, Button, Form } from 'antd';

const { TextArea } = Input;

const TextAreaType = ({
   question,
   selectedAnswer,
   options,
   buttonsState,
   onSubmitAnswer,
   selectedOption,
   setSelectedOption
   }) => {
   const [form] = Form.useForm();
   const [textInput, setTextInput] = useState();
   const setFieldValue = useCallback( 
      () => {
         setSelectedOption();
         if (selectedAnswer) {
            form.setFieldsValue({ textArea: selectedAnswer });
            setSelectedOption(selectedAnswer);
         }
      },
      [selectedAnswer, question],
   );

   const onFinish = (type) => {
      onSubmitAnswer(type, form.getFieldValue("textArea"))
      form.resetFields();
   };

   const handleTextInput = (event) => {
      setTextInput(event.target.value);
      setSelectedOption(event.target.value);
   };

   useEffect(() => {
      form.resetFields();
      setFieldValue();
   }, [setFieldValue]);

   return (
      <Row justify="center">
         <Form
            form={form}
            style={{ width: '100%'}}
         >
            <Col md={24} className="options-wrapper p-30 mt-40 mb-80">
               <Row justify="center">
                  <Col md={24}>
                     <h2 className="text-center mt-10 mb-50" dangerouslySetInnerHTML={{ __html: question.title && question.title }} />
                  </Col>
                  <Col md={24}>
                     <Form.Item
                        name="textArea"
                        onChange={handleTextInput}
                        className="mb-0"
                     >
                        <TextArea 
                           placeholder="Ingrese su respuesta aquí"
                           style={{ width: '100%', height: 150, fontSize: '27px' }}
                           value={selectedAnswer}
                        />
                     </Form.Item>
                  </Col>
               </Row>
            </Col>
            <Col md={24} className="mb-40">
               <Row>
                  <Col md={5}>
                     <Button 
                        className={'secondary-button'}
                        size="large"
                        onClick = {() => onFinish('previus')}
                        block
                     >
                        Anterior
                     </Button>
                  </Col>
                  <Col md={ buttonsState.isCurrentLastQuestion ? 12 : 14 }></Col>
                  <Col md={ buttonsState.isCurrentLastQuestion ? 7 : 5 } justify="end">
                     <Button
                        disabled={ buttonsState.isCurrentLastQuestion ? !selectedOption : buttonsState.lastQuestion && buttonsState.questionsUnanswered }
                        className={(buttonsState.isCurrentLastQuestion ? !selectedOption : buttonsState.lastQuestion && buttonsState.questionsUnanswered )
                                 ? 'button-disabled' : ''}
                        type="primary" 
                        size="large" 
                        onClick = {() => onFinish('foward')}
                        block
                     >
                        {buttonsState.isCurrentLastQuestion ? 'Terminar cuestionario' : 'Siguiente'}
                     </Button>
                  </Col>
               </Row>
            </Col>
         </Form>
      </Row>
   );
};

export default TextAreaType;